import { ISnapshot } from '_/types/snapshots/snapshot.types';
import { formatDateTime } from '_/utils/dateUtils';
import { snapshotNeedsAttention, SnapshotOptions } from '_/utils/timeUtils';

export const snapshotNeedsAttentionOptions: SnapshotOptions = {
  pendingQATime: 1,
  qaTime: 3,
  time: 'hour',
};

export type FormattedSnapshot = Omit<
  ISnapshot,
  'addedAt' | 'startedAt' | 'stoppedAt' | 'updatedAt' | 'collectBy' | 'deliverBy' | 'mustFinishBy' | 'childSnapshots'
> & {
  addedAt: string;
  startedAt: string;
  stoppedAt: string;
  updatedAt: string;
  collectBy: string;
  deliverBy: string;
  mustFinishBy: string;
  isLegacyCrawlRun: boolean;
  childSnapshots: FormattedSnapshot[] | null;
  needsAttention: boolean;
};

export function formatSnapshots(snapshots: ISnapshot[], childSnapshots: ISnapshot[] = []): FormattedSnapshot[] {
  return snapshots.map((snapshot) => ({
    ...snapshot,
    addedAt: snapshot.addedAt ? formatDateTime(snapshot.addedAt) : '',
    startedAt: snapshot.startedAt ? formatDateTime(snapshot.startedAt) : '',
    stoppedAt: snapshot.stoppedAt ? formatDateTime(snapshot.stoppedAt) : '',
    updatedAt: snapshot.updatedAt ? formatDateTime(snapshot.updatedAt) : '',
    collectBy: snapshot.collectBy ? formatDateTime(snapshot.collectBy) : '',
    deliverBy: snapshot.deliverBy ? formatDateTime(snapshot.deliverBy) : '',
    mustFinishBy: snapshot.mustFinishBy ? formatDateTime(snapshot.mustFinishBy) : '',
    isLegacyCrawlRun: snapshot.managedBy === 'LEGACY',
    childSnapshots:
      snapshot.chunked && childSnapshots ? formatSnapshots(childSnapshots[snapshot.id] || [], childSnapshots) : null,
    needsAttention: snapshotNeedsAttention(snapshot.status, snapshot.statusUpdatedAt, snapshotNeedsAttentionOptions),
  }));
}
